export default "__VITE_ASSET__Dpmpp7zk__"